import { AuditoriaCopiaForm } from "../../../presentation/schemas/Auditoria_auditoria/auditoria_copia";
import { ICopiaAuditoriaUseCase } from "../../../presentation/useCases/create/copia_auditoria_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class CopiaAuditoriaUseCase implements ICopiaAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) { }

  async copiaAuditoria(form: AuditoriaCopiaForm): Promise<void> {
    await this.repository.copiaAuditoria(form);

  }
}


